import { List, Stack } from "@mui/material";

import { AssignmentWidget } from "@/common/components/assignments/assignment-widget/AssignmentWidget";

import { AssignmentsHeader } from "./components/header/AssignmentsHeader";
import { useAssignments } from "./hooks/useAssignments";

export function Assignments() {
  const { assignments, selectedCounselorId, onCounselorChange } = useAssignments();

  return (
    <Stack flex={1} overflow="hidden" borderRadius={0.5} border={"1px solid"} borderColor={"fsw.blue-10"}>
      <AssignmentsHeader
        count={assignments.length}
        selectedCounselorId={selectedCounselorId}
        onCounselorChange={onCounselorChange}
      />

      <List disablePadding sx={{ overflowY: "auto", flex: 1 }}>
        {assignments.map((assignment) => (
          <AssignmentWidget key={assignment.assignmentId} assignment={assignment} />
        ))}
      </List>
    </Stack>
  );
}
